import React, { useEffect, useState } from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
import { ArrowForward } from '@mui/icons-material';
export const CarePlanTimelineListItem = (props) => {
    const { timelineActivity } = props;
    // default text color and background color to "Removed" and update it for added / changed
    // const [textColorPreviousState, setTextColorPreviousState] = useState('#D32F2F');
    // const [backgroundColorPreviousState, setBackgroundColorPreviousState] = useState('#FBEBEB');
    // const [textColorNewState, setTextColorNewState] = useState('#D32F2F');
    // const [backgroundColorNewState, setBackgroundColorNewState] = useState('#FBEBEB');
    // const [changed, setChanged] = useState(false);
    // const [added, setAdded] = useState(false);
    // const [removed, setRemoved] = useState(false);
    const [textValue, setTextValue] = useState('');
    useEffect(() => {
        // added if no previous state
        if (timelineActivity.previousState === null && timelineActivity.newState !== null) {
            // setTextColorPreviousState('#4CAF50');
            // setBackgroundColorPreviousState('#EEF7EE');
            // setAdded(true);
            // setChanged(false);
            // setRemoved(false);
            setTextValue('Added: ' + timelineActivity.newState);
        }
        // changed if both states
        if (timelineActivity.previousState !== null && timelineActivity.newState !== null) {
            // setTextColorPreviousState('#757575');
            // setBackgroundColorPreviousState('#F5F5F5');
            // setTextColorNewState('#2C78EB');
            // setBackgroundColorNewState('#EAF2FD');
            // setChanged(true);
            // setAdded(false);
            // setRemoved(false);
            setTextValue(React.createElement(React.Fragment, null,
                "Changed: ",
                timelineActivity.previousState,
                React.createElement(ArrowForward, { style: { fontSize: '18px', marginTop: 'auto', marginBottom: 'auto', marginLeft: '4px', marginRight: '4px' } }),
                timelineActivity.newState));
        }
        if (timelineActivity.previousState !== null && timelineActivity.newState === null) {
            // setTextColorPreviousState('#757575');
            // setBackgroundColorPreviousState('#F5F5F5');
            // setTextColorNewState('#2C78EB');
            // setBackgroundColorNewState('#EAF2FD');
            // setChanged(false);
            // setAdded(false);
            // setRemoved(true);
            setTextValue('Removed: ' + timelineActivity.previousState);
        }
    });
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: timelineActivity.notes ?? '', value: textValue, backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }))));
};
